<div fxLayout="column" fxLayoutAlign="center center">
  <div class="title-container" fxLayout fxLayoutAlign="center center">
    <h1>We received your submission!</h1>
  </div>
  <span *ngIf="confirmationMessage; then confirmationMsg; else defaultMsg"></span>
  <ng-template #defaultMsg>{{
    isAdded ? 'You have been added to the system.' : 'You have been updated in the system.'
  }}</ng-template>
  <ng-template #confirmationMsg
    ><span class="confirmation-message" [innerHTML]="confirmationMessage | safeHtml"></span
  ></ng-template>
  <div *ngIf="invoice" class="container">
    <app-application-confirmation-payment
      [invoice]="invoice"
      [checkInstructions]="checkInstructions"
      [isConfirmationPage]="true"
    ></app-application-confirmation-payment>
  </div>
</div>
